import React from "react";
import DangerIcon from "./DangerIcon/DangerIcon";
import "./DangerButton.css";

const DangerButton = (props) => {
  return (
    <button className="danger-button" onClick={props.handleDangerButtonOnClick}>
      <DangerIcon />
      {props.dangerButtonText}
    </button>
  );
};

export default DangerButton;
